import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';

import RteVideo from './RteVideoComponent.vue';

export default Node.create({
  name: 'rteVideo',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      videosource: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'rte-video',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['rte-video', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(RteVideo);
  },
});
